import * as React from 'react';
import { useState } from 'react';
import {
  Box,
  Button,
  Loader,
  IconButton,
  IconButtonProps,
  ButtonProps,
} from '@wix/design-system';
import { saveAs } from 'file-saver';
import DownloadImport from 'wix-ui-icons-common/DownloadImport';
import { HttpClient } from '@wix/http-client';

const httpClient = new HttpClient();

export const xsrfCookieKey = 'XSRF-TOKEN';
export const xsrfHeaderKey = 'x-xsrf-token';

export const getXsrfCookie = () => {
  const x = document.cookie.indexOf(xsrfCookieKey);
  const y = document.cookie.indexOf('=', x);
  const z = document.cookie.includes(';', y)
    ? document.cookie.indexOf(';', y)
    : undefined;
  return document.cookie.substring(y + 1, z);
};

const downloadPdf = (pdfUrl: string, token: string) => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return httpClient.post(
    `${pdfUrl}?timezone=${encodeURIComponent(timezone)}`,
    { token, 'x-xsrf-token': getXsrfCookie() },
    {
      headers: {
        'content-type': 'application/json',
        Accept: 'text/html,application/xhtml+xml',
      },
      responseType: 'blob',
    },
  );
};

const MobilePdfButton = (props: IconButtonProps) =>
  props.title ? (
    <Button
      priority="secondary"
      {...(props as ButtonProps)}
      prefixIcon={<DownloadImport />}
    >
      {props.title}
    </Button>
  ) : (
    <IconButton priority="secondary" {...props}>
      <DownloadImport />
    </IconButton>
  );

export type PdfDownloaderProps = {
  token: string;
  text: string;
  pdfUrl: string;
  onDownloadPDF: () => void;
  onDownloadFail: () => void;
  newMobileViewEnabled?: boolean;
};

export const PdfDownloader = ({
  token,
  text,
  pdfUrl,
  onDownloadPDF,
  onDownloadFail,
  newMobileViewEnabled = false,
}: PdfDownloaderProps) => {
  const [showLoader, setShowLoader] = useState(false);

  // @ts-expect-error
  const PdfButton = (props) =>
    newMobileViewEnabled ? (
      <MobilePdfButton {...props} title={text} />
    ) : (
      <Button theme="whiteblueprimary" {...props} />
    );

  return (
    <PdfButton
      dataHook="download-pdf-button"
      onClick={() => {
        setShowLoader(true);
        downloadPdf(pdfUrl, token)
          .then((response) => {
            saveAs(response.data, 'Invoice.pdf');
            onDownloadPDF();
          })
          .catch(onDownloadFail)
          .then(() => setShowLoader(false));
      }}
    >
      <Box align="center" {...(newMobileViewEnabled ? {} : { width: '110px' })}>
        {showLoader ? <Loader size="tiny" /> : text}
      </Box>
    </PdfButton>
  );
};
